<!-- eslint-disable no-irregular-whitespace -->
<template>
  <page>

    <div class="mv-area-first">

      <!-- スライダー -->
      <div class="main-view-slick__container">
        <ul class="main-view-slick of">
          <li><img class="slick-slide" src="~@/assets/images/mv-img-2.png" width="930" height="400"></li>
          <li><img class="slick-slide" src="~@/assets/images/mv-img-3.png" width="930" height="400"></li>
          <li><img class="slick-slide" src="~@/assets/images/mv-img-1.png" width="930" height="400"></li>
          <li><img class="slick-slide" src="~@/assets/images/mv-img-2.png" width="930" height="400"></li>
          <li><img class="slick-slide" src="~@/assets/images/mv-img-3.png" width="930" height="400"></li>
          <li><img class="slick-slide" src="~@/assets/images/mv-img-1.png" width="930" height="400"></li>
        </ul>
      </div>
      <!-- /スライダー -->

     <div class="mv-area-second">

        <div class="mv-area-second__container">
          <div class="mv-area-second__paymentBox">
            <div class="mv-area-second__paymentBox__inner">
              <img class="teigaku" src="~@/assets/images/teigaku.png" alt="">
              <img class="price" src="~@/assets/images/text_pc.png" alt="">
            </div>
          </div>
        </div>


        <div class="find-area__inner">
          <div class="find-area__container">
            <p class="find-area-title">
              利用可能なクルマを探す
            </p>
            <div class="find-area__buttonBox">
              <router-link to="/car?area=埼玉"><span class="find-area-button__large">埼玉</span>エリアで探す</router-link>
              <router-link to="/car?area=大阪"><span class="find-area-button__large">大阪</span>エリアで探す</router-link>
            </div>
            <div class="find-area__buttonBox">
              <router-link to="/car?area=宮城"><span class="find-area-button__large">宮城</span>エリアで探す</router-link>
              <router-link to="/car?area=福岡"><span class="find-area-button__large">福岡</span>エリアで探す</router-link>
            </div>
          </div>
        </div>
      </div>

	</div>
  <!-- /TOP KV -->

  <!-- スズキ定額マイカーのポイント -->
  <div class="top-point-content">

    <div class="wrapper">

      <!-- 見出し -->
      <center>
        <div id="top-sec-point" class="top-point-content-title">
          <div class="top-point-content-title-img">
            <img src="~@/assets/images/point-title-img.png" width="664" height="61" class="pc tab">
            <img src="~@/assets/images-sp/point-title-img.png" width="664" height="61" class="mobi">
          </div>
        </div>
      </center>
      <!-- /見出し -->

      <div class="top-point-content-main-text">
        『スズキ定額マイカー』は6ケ月間定額で、<br class="mobi">スズキ車のオーナーになれる<br>サブスクリプションサービスです。
      </div>

      <!-- ポイント一覧 -->
      <div class="top-point-content-in">

        <!-- POINT 01 -->
        <section class="sec-1">

          <div class="top-point-content-in-box">

            <div class="top-point-content-in-box-title">
              <span class="big red">6ケ月契約</span>だから<br class="mobi"><span class="big blue">気軽</span>に利用できる。<br><span class="big blue">車との新しい付き合い方</span><br class="mobi">のご提案。
            </div>

            <center>
              <div class="top-point-content-in-box-img-1">
                <img src="~@/assets/images/point-img-1.png" width="743" height="358" class="pc tab">
                <img src="~@/assets/images-sp/point-img-1.png" width="587" height="353" class="mobi">
              </div>
            </center>

            <center>
              <div class="top-point-content-in-box-img-4">
                <img src="~@/assets/images/point-img-4.png" width="1368" height="754" class="pc tab">
                <img src="~@/assets/images-sp/point-img-4.png" width="1120" height="774" class="mobi">
              </div>
            </center>

            <div class="top-point-content-in-box-text">
              「クルマが必要なのは短期間だけ」<br class="mobi">「クルマがある生活を試してみたい」<br>「新車の購入を考えているけど、<br class="mobi">実際に試してみたい」<br>そんな、<span class="line">お客様のさまざまなニーズ</span><br class="mobi">にお応えします。
            </div>

            <center>
              <router-link to="/service#link01" class="top-point-content-in-box-link-btn sans">
                詳しくはこちら
              </router-link>
            </center>

          </div>

        </section>
        <!-- /POINT 01 -->

        <!-- POINT 02 -->
        <section class="sec-2">

          <div class="top-point-content-in-box">

            <div class="top-point-content-in-box-title">
              申し込みは<span class="big red">スマホで簡単。</span><br>納車まで来店不要だから<br class="mobi"><span class="big blue">手続きラクラク。</span>
            </div>

            <center>
              <div class="top-point-content-in-box-img-2">
                <img src="~@/assets/images/point-img-2.png" width="888" height="235" class="pc tab">
                <img src="~@/assets/images-sp/point-img-2.png" width="557" height="500" class="mobi">
              </div>
            </center>

            <div class="top-point-content-in-box-text">
              申し込み・審査はWEBで対応。<br class="mobi">契約手続きも<br class="pc tab">自宅でできるので、<br class="mobi">納車まで来店不要。<br><span class="line">自分の時間に合わせて</span><br class="mobi">手続きを進めることができます。
            </div>

            <center>
              <router-link to="/service/#link02" class="top-point-content-in-box-link-btn sans">
                詳しくはこちら
              </router-link>
            </center>

          </div>

        </section>
        <!-- /POINT 02 -->

        <!-- POINT 03 -->
        <section class="sec-3">

          <div class="top-point-content-in-box">

            <div class="top-point-content-in-box-title">
              <span class="big red">先進安全技術</span>を搭載した<br>スズキ車をラインアップ
            </div>

            <center>
              <div class="top-point-content-in-box-img-3">
                <img src="~@/assets/images/point-img-3.png" width="858" height="260" class="pc tab">
                <img src="~@/assets/images-sp/point-img-3.png" width="538" height="453" class="mobi">
              </div>
            </center>

            <div class="top-point-content-in-box-text">
              対象車種は、<br class="mobi">「スズキセーフティサポート」<br class="mobi">を搭載したスズキ認定中古車。<br>
              初めて車を運転される方から、<br class="mobi">子育て世代、運転に不安を感じはじめた<br>シニア世代の方まで、<span class="line">安心・安全な<br class="mobi">マイカーライフ</span><br class="pc tab">を送れます。
            </div>

            <center>
              <router-link to="/service#link03" class="top-point-content-in-box-link-btn sans">
                詳しくはこちら
              </router-link>
            </center>

          </div>

        </section>
        <!-- /POINT 03 -->

      </div>
      <!-- /ポイント一覧 -->

      <div class="top-point-content-big-text">
        手軽な乗り方で<br>身軽なくらしが<br class="mobi">走り出す。
      </div>

      <div class="top-point-content-text">
        あなたの生活に<br class="mobi">フィットしたカーライフを、<br>はじめてみませんか。
      </div>

    </div>
  </div>
  <!-- /スズキ定額マイカーのポイント -->

  <!-- ラインナップはこちら -->
  <div class="top-lineup-content">

    <!-- 見出し -->
    <center>
      <div class="top-lineup-content-title">
        <div class="top-lineup-content-title-img">
          <img src="~@/assets/images/lineup-title-img.png" width="804" height="128">
        </div>
      </div>
    </center>
    <!-- /見出し -->

    <!-- lineup-content-in -->
    <div class="top-lineup-content-in">

      <!-- 軽乗用車一覧 -->
      <section>

        <center>
          <div class="top-lineup-content-in-title">
            軽乗用車
          </div>
        </center>

        <ul class="top-lineup-content-in-list" v-if="!loading">

          <li v-for="item in lineupLight" :key="item.item_id" :class="{ osusume: item.recommendFlag }">
            <div class="top-lineup-content-in-list-in">
              <div class="top-lineup-content-in-list-in-img">
                <img :src="item.imagePaths[0]" width="600" height="300">
              </div>
              <center>
                <div class="top-lineup-content-in-list-in-logo-img">
                  {{ item.carName }}
                </div>
              </center>
              <div class="top-lineup-content-in-list-in-price sans">
                月額{{ item.carName == 'アルト' ? Number(32000).toLocaleString() : Number(item.price).toLocaleString() }}円<span class="tax">（税込）</span>〜
              </div>
              <ul class="top-lineup-content-in-list-in-btn-list">
                <li v-if="item.saitamaHasStocks"><router-link :to="`/car?area=埼玉&carName=${item.carName}`">埼玉<span class="sans">エリアで探す</span></router-link></li>
                <li v-if="item.osakaHasStocks"><router-link :to="`/car?area=大阪&carName=${item.carName}`">大阪<span class="sans">エリアで探す</span></router-link></li>
                <li v-if="item.miyagiHasStocks"><router-link :to="`/car?area=宮城&carName=${item.carName}`">宮城<span class="sans">エリアで探す</span></router-link></li>
                <li v-if="item.fukuokaHasStocks"><router-link :to="`/car?area=福岡&carName=${item.carName}`">福岡<span class="sans">エリアで探す</span></router-link></li>
              </ul>
            </div>
          </li>
        </ul>

        <div class="top-lineup-content-in-list-in-logo-img" v-else>
            <center>
                読込中...
            </center>
        </div>

      </section>
      <!-- /軽乗用車一覧 -->

      <!-- 普通自動車一覧 -->
      <section>

        <center>
          <div class="top-lineup-content-in-title">
            乗用車
          </div>
        </center>

        <ul class="top-lineup-content-in-list" v-if="!loading">

          <li v-for="item in lineupNormal" :key="item.item_id" :class="{ osusume: item.recommendFlag }">
            <div class="top-lineup-content-in-list-in">
              <div class="top-lineup-content-in-list-in-img">
                <img :src="item.imagePaths[0]" width="601" height="301">
              </div>
              <center>
                <div class="top-lineup-content-in-list-in-logo-img">
                  {{ item.carName }}
                </div>
              </center>
              <div class="top-lineup-content-in-list-in-price sans">
                月額{{ Number(item.price).toLocaleString() }}円<span class="tax">（税込）</span>〜
              </div>
              <ul class="top-lineup-content-in-list-in-btn-list">
                <li v-if="item.saitamaHasStocks"><router-link :to="`/car?area=埼玉&carName=${item.carName}`">埼玉<span class="sans">エリアで探す</span></router-link></li>
                <li v-if="item.osakaHasStocks"><router-link :to="`/car?area=大阪&carName=${item.carName}`">大阪<span class="sans">エリアで探す</span></router-link></li>
                <li v-if="item.miyagiHasStocks"><router-link :to="`/car?area=宮城&carName=${item.carName}`">宮城<span class="sans">エリアで探す</span></router-link></li>
                <li v-if="item.fukuokaHasStocks"><router-link :to="`/car?area=福岡&carName=${item.carName}`">福岡<span class="sans">エリアで探す</span></router-link></li>
              </ul>
            </div>
          </li>

        </ul>

        <div class="top-lineup-content-in-list-in-logo-img" v-else>
            <center>
                読込中...
            </center>
        </div>

      </section>
      <!-- /普通自動車一覧 -->

    </div>
    <!-- /lineup-content-in -->

    <!-- ラインナップバナー -->
    <div class="lineup-main-banner">

      <center>
        <div class="lineup-main-banner-title">
          <span class="big pink">スズキ定額マイカー</span>で<br class="mobi"><span class="big blue">新しいカーライフ</span>を<span class="big italic">！</span>
        </div>
      </center>

      <!-- lineup-main-banner-box -->
      <div class="lineup-main-banner-box of">

        <div class="lineup-main-banner-box-img">
          <img src="~@/assets/images/main-banner-iphone-img.png" width="261" height="486" class="pc tab">
          <img src="~@/assets/images-sp/main-banner-iphone-img.png" width="500" height="400" class="mobi">
        </div>

        <div class="lineup-main-banner-box-info">
          <div class="lineup-main-banner-box-info-logo-img">
            <img src="~@/assets/images/logo-new.png" width="649" height="90">
          </div>

          <div class="lineup-main-banner-box-info-main">

            <div class="lineup-main-banner-box-info-main-title">
              <span class="big">自動車保険、諸費用</span><span class="big red">コミコミ<span class="italic">！</span></span>
            </div>

            <div class="lineup-main-banner-box-info-main-price of">
              <div class="lineup-main-banner-box-info-main-price-text">
                月額
              </div>
              <div class="lineup-main-banner-box-info-main-price-in">
                32,000
              </div>
              <div class="lineup-main-banner-box-info-main-price-text-2">
                円<br>(税込)～
              </div>
            </div>

          </div>
          <div class="lineup-main-banner-box-info-text sans">
            『スズキ定額マイカー』は6ケ月間定額で、<br class="mobi tab">スズキ車のオーナーになれる<br>サブスクリプションサービスです。
          </div>

          <router-link to="/service" class="lineup-main-banner-box-info-btn sans">
            詳しくはこちら
          </router-link>

        </div>

      </div>

    </div>
    <!-- /ラインナップバナー -->

  </div>
  <!-- /ラインナップはこちら -->

  <!-- ご利用までの流れ -->
  <div id="top-sec-flow" class="top-flow-content">
    <div class="wrapper">

      <!-- 見出し -->
      <center>
        <div class="top-flow-content-title">
          ご利用までの流れ
        </div>
      </center>
      <!-- /見出し -->

      <ul class="top-flow-content-list">
        <li>
          <div class="top-flow-content-list-img">
            <img src="~@/assets/images/flow-img-1.jpg" width="220" height="190">
          </div>
          <div class="top-flow-content-list-title">STEP 01</div>
          <div class="top-flow-content-list-text">
            クルマを選ぶ
          </div>
        </li>
        <li>
          <div class="top-flow-content-list-img">
            <img src="~@/assets/images/flow-img-2.jpg" width="220" height="190">
          </div>
          <div class="top-flow-content-list-title">STEP 02</div>
          <div class="top-flow-content-list-text">
            審査を申し込む
          </div>
        </li>
        <li>
          <div class="top-flow-content-list-img">
            <img src="~@/assets/images/flow-img-3.jpg" width="220" height="190">
          </div>
          <div class="top-flow-content-list-title">STEP 03</div>
          <div class="top-flow-content-list-text">
            成約メールを<br class="pc tab">送信する
          </div>
        </li>
        <li>
          <div class="top-flow-content-list-img">
            <img src="~@/assets/images/flow-img-4.jpg" width="220" height="190">
          </div>
          <div class="top-flow-content-list-title">STEP 04</div>
          <div class="top-flow-content-list-text">
            お手元に届いた書類に必要事項を記入、<br class="pc tab">郵送する
          </div>
        </li>
        <li>
          <div class="top-flow-content-list-img">
            <img src="~@/assets/images/flow-img-5.jpg" width="220" height="190">
          </div>
          <div class="top-flow-content-list-title">STEP 05</div>
          <div class="top-flow-content-list-text">
            お店でクルマを受取る
          </div>
        </li>
      </ul>

      <center>
        <router-link to="/flow" class="top-flow-content-btn sans">
          詳しくはこちら
        </router-link>
      </center>

    </div>
  </div>
  <!-- /ご利用までの流れ -->

  <!-- 対応エリア・店舗 -->
  <div id="top-sec-shop" class="top-area-content">
    <div class="wrapper">

      <!-- 見出し -->
      <center>
        <div class="top-area-content-title">
          対応エリア・店舗
        </div>
      </center>
      <!-- /見出し -->

      <div class="find-area__buttonBox">
        <router-link to="/car?area=埼玉"><span class="find-area-button__large">埼玉</span>エリアで探す</router-link>
        <router-link to="/car?area=大阪"><span class="find-area-button__large">大阪</span>エリアで探す</router-link>
      </div>
      <div class="find-area__buttonBox">
        <router-link to="/car?area=宮城"><span class="find-area-button__large">宮城</span>エリアで探す</router-link>
        <router-link to="/car?area=福岡"><span class="find-area-button__large">福岡</span>エリアで探す</router-link>
      </div>
    </div>
  </div>
  <!-- /対応エリア・店舗 -->

  <!-- スライダー -->
  <ul class="top-slider-list of">
    <li><img src="~@/assets/images/slider-img-1.jpg" width="562" height="400"></li>
    <li><img src="~@/assets/images/slider-img-2.jpg" width="592" height="400"></li>
    <li><img src="~@/assets/images/slider-img-3.jpg" width="592" height="400"></li>
    <li><img src="~@/assets/images/slider-img-1.jpg" width="562" height="400"></li>
    <li><img src="~@/assets/images/slider-img-2.jpg" width="592" height="400"></li>
    <li><img src="~@/assets/images/slider-img-3.jpg" width="592" height="400"></li>
  </ul>
  <!-- /スライダー -->

  <!-- 新着情報 -->
  <div class="top-news-content">
    <div class="wrapper">

      <div class="top-news-content-title">新着情報</div>

      <ul class="top-news-content-list sans" v-if="!loading && notices.length > 0">
        <li v-for="notice in notices" :key="notice.id">
          <div class="top-news-content-list-date">{{ notice.publish_date }}</div>
          <div class="top-news-content-list-title">
            {{ notice.title ? `${notice.title}　` : ''}}{{ notice.body }}
          </div>
        </li>
      </ul>
      <ul class="top-news-content-list sans" v-else>
        <li>
          <div class="top-news-content-list-title">
            新着情報はありません。
          </div>
        </li>
      </ul>

    </div>
  </div>
  <!-- /新着情報 -->

  <!-- top-main-content -->
  <div class="top-main-content">


    <!-- よくあるご質問・ご相談 -->
    <div id="top-sec-faq" class="top-qa-content">
      <div class="wrapper">

        <!-- 見出し -->
        <center>
          <div class="top-qa-content-title">
            よくあるご質問・ご相談
          </div>
        </center>
        <!-- /見出し -->

        <ul class="top-qa-content-list of sans">
          <li class="li-1 now">サービス内容</li>
          <li class="li-2">ご利用条件</li>
          <li class="li-3">料金・お支払い</li>
          <li class="li-4">申し込み手続き</li>
          <li class="li-5">ご利用中</li>
          <li class="li-6">その他</li>
        </ul>

        <!-- サービス内容 -->
        <div class="top-qa-content-in sans con-1 now">

          <dl>
            <dt>スズキ定額マイカーの特長はなんですか？</dt>
            <dd>
              <p>頭金なしの6か月間定額で、スズキ車のオーナーになれるサブスクリプションサービスです。<br>
                月額料金に自動車保険が含まれており、ＥＴＣやドライブレコーダーも標準装備しています。</p>
            </dd>
          </dl>

          <dl>
            <dt>利用期間は自由に選べるのでしょうか？</dt>
            <dd>
              <p>利用期間は6ケ月のみとなります。</p>
            </dd>
          </dl>

          <dl>
            <dt>月額費用には何が含まれますか？</dt>
            <dd>
              <p>⾞両利⽤料に加え、ご契約期間中に発生する各種税金、登録（届出）手数料、保険料（自賠責保険・自動車保険）が含まれます。<br>
                  ガソリン代、駐車場代などはお客様のご負担となります。</p>
            </dd>
          </dl>

          <dl>
            <dt>標準装備を教えてください。</dt>
            <dd>
              <p>ドライブレコーダー、カーナビ、ETC、フロアマット、ドアバイザ－はすべてのクルマに標準搭載装備として設置されています。</p>
            </dd>
          </dl>

          <dl>
            <dt>自動車ローンプランや残価設定型プランとの違いはなんですか？</dt>
            <dd>
              <p>自動車ローンや残価設定型プランの場合、自動車税や自動車保険のお手続きはお客様で行っていただきます。<br>
                  スズキ定額マイカーでは税金や自動車保険はすでに月額料金に含まれているので、ご自身でする手間がかかりません。</p>
            </dd>
          </dl>

          <dl>
            <dt>ホームページ上に掲載されているクルマ以外でも申し込めますか？</dt>
            <dd>
              <p>本サービスの対象となっているクルマはホームページ上に掲載されているクルマのみとなっております。</p>
            </dd>
          </dl>

          <dl>
            <dt>申し込み前にクルマを確認することはできますか？</dt>
            <dd>
              <p>実車確認はできません。サイト上の車両状態証明書で車両状態を確認することができます。</p>
            </dd>
          </dl>

          <dl>
            <dt>「わ」ナンバーになりますか？</dt>
            <dd>
              <p>レンタカーではないので「わ」や「れ」ナンバーにはなりません。</p>
            </dd>
          </dl>

        </div>
      <!-- /サービス内容 -->

        <!-- ご利用条件 -->
        <div class="top-qa-content-in sans con-2">

          <dl>
            <dt>車内は喫煙可能ですか？</dt>
            <dd>
              <p>全車禁煙車となっております（電子タバコを含む）。喫煙された場合、返却時にルームクリーニング費用の清算が必要です。</p>
            </dd>
          </dl>

          <dl>
            <dt>
              ペットを乗せて使うことはできますか？
            </dt>
            <dd>
              <p>ペットを乗せてご利用される場合は、必ずケージをご使用いただくようお願いいたします。返却時に、ペットによる汚れ（毛）・臭いの除去等が必要な場合は、原状回復に必要な費用をお支払いいただく場合もございます。</p>
            </dd>
          </dl>

          <dl>
            <dt>走行距離の制限はありますか？</dt>
            <dd>
              <p>6ケ月で6,000km以内の走行距離制限がございます。制限を超過された場合は、超過1kmにつき10円（税込）が別途発生いたします。</p>
            </dd>
          </dl>

          <dl>
            <dt>法人の申し込みはできますか？</dt>
            <dd>
              <p>できません。個人のご利用のみとなります。</p>
            </dd>
          </dl>

          <dl>
            <dt>未成年でも申し込みできますか？</dt>
            <dd>
              <p>未成年の方はお申し込みできません</p>
            </dd>
          </dl>

          <dl>
            <dt>取り扱い店舗以外の都道府県に在住ですが、利用可能でしょうか？</dt>
            <dd>
              <p>取り扱い店舗と同一都道府県内に在住の方のみご利用可能です。</p>
            </dd>
          </dl>

          <dl>
            <dt>複数台の申し込みはできますか？</dt>
            <dd>
              <p>同時に複数台のお申し込みは出来ません。</p>
            </dd>
          </dl>

        </div>
      <!-- /ご利用時の注意事項 -->

        <!-- 料金・お支払い -->
        <div class="top-qa-content-in sans con-3">


          <dl>
            <dt>頭金は必要ですか？</dt>
            <dd>
              <p>不要です。</p>
            </dd>
          </dl>

          <dl>
            <dt>ボーナス払いは利用できますか？</dt>
            <dd>
              <p>ボーナス払いは利用できません。毎月定額払いとなります。</p>
            </dd>
          </dl>

          <dl>
            <dt>支払方法を教えてください</dt>
            <dd>
              <p>クレジットカードでのお支払いのみとなります。</p>
            </dd>
          </dl>

          <dl>
            <dt>契約者と異なる名義のクレジットカードでも登録が可能ですか？</dt>
            <dd><p>契約者と同じ名義のクレジットカードをご登録ください。</p></dd>
          </dl>

          <dl>
            <dt>引き落としはいつからですか？</dt>
            <dd>
              <p>契約開始月の翌月10日にクレジットカード会社へ請求します。<br>
                以降、毎月10日に登録いただいたクレジットカード会社へ請求します。<br>
                ※クレジットカード会社からお客さまへのご請求日はクレジットカード会社により異なります
              </p>
            </dd>
          </dl>

          <dl>
            <dt>クルマ返却時に追加で費用が発生することはありますか？</dt>
            <dd><p>一般財団法人日本自動車査定協会登録の中古自動車査定士が、返却自動車を減点方式にて査定をさせていただきます。<br>
              査定の結果、引渡時の原状と異なるときは原状回復に要する費用が50点（50,000円）以上の場合、50点を超過した費用をお客様にご負担いただきます。<br>
              6ケ月で6,000km以内の走行距離制限を超過された場合は、超過1kmにつき10円（税込）が別途発生いたします。</p></dd>
          </dl>

        </div>
        <!-- /料金・お支払い -->

        <!-- 申込み手続き -->
        <div class="top-qa-content-in sans con-4">

          <dl>
            <dt>申し込みから車を受け取る（納車）までの期間はどのくらいですか？</dt>
            <dd>
              <p>お申し込みから納車までに、おおよそ1ヶ月程度お日にちをいただきます。</p>
            </dd>
          </dl>

          <dl>
            <dt>住民票住所でなく実際に住んでいる住所で、申し込みできますか？</dt>
            <dd>
              <p>住民票がある住所でのみ、申し込みいただけます。</p>
            </dd>
          </dl>

          <dl>
            <dt>審査にかかる時間を教えてください</dt>
            <dd>
              <p>２～３営業日以内に審査結果をご登録いただいたメールアドレスへご連絡いたします。</p>
            </dd>
          </dl>

          <dl>
            <dt>申し込み後にキャンセルはできますか？</dt>
            <dd>
              <p>キャンセルは可能です。<br>
                ・申し込みから成約メール送信前まで → キャンセル料なし<br>
                ・成約メール送信から名義変更前まで → 月額利用料1ヶ月分<br>
                ・名義変更以降 → 中途解約扱いで、6ヶ月分の月額利用料</p>
            </dd>
          </dl>

          <dl>
            <dt>申し込みをしましたが、メールが届きません</dt>
            <dd>
              <p>迷惑メールなどに振り分けられていないかをご確認ください。また、ドメイン受信設定やメールフィルターで排除されている可能性があります。<br>
                メールを確認できない場合には、スズキ定額マイカーお客様センターへお問い合わせください。</p>
            </dd>
          </dl>

          <dl>
            <dt>審査結果の詳細を教えてください</dt>
            <dd>
              <p>詳細はお答えすることはできません。ご容赦ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>直接店舗で申し込みたい</dt>
            <dd>
              <p>インターネットでのみ、お申し込みが可能です。</p>
            </dd>
          </dl>

          <dl>
            <dt>クルマの受け取りは、取り扱い店舗のみですか？</dt>
            <dd>
              <p>車両のお渡し（納車）は、取り扱い店舗のみとなります。</p>
            </dd>
          </dl>

          <dl>
            <dt>自宅までクルマは配送してもらえますか？</dt>
            <dd>
              <p>ご自宅へのお届けは行っておりません。店舗までお越しください。</p>
            </dd>
          </dl>

        </div>
        <!-- /申込み手続き -->

        <!-- ご利用中 -->
        <div class="top-qa-content-in sans con-5">

          <dl>
            <dt>契約期間中に県外（府外）に転居した場合はどうなりますか？</dt>
            <dd>
              <p>ご利用中にご契約いただいた県外（府外）へお引越しされる場合、中途解約となります。<br>
                転居が決まり次第、スズキ定額マイカーお客様センターまでご連絡ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>他の人も運転できますか？</dt>
            <dd>
              <p>運転者はご契約者様、もしくはご契約者様が許諾した方のみが運転できます。</p>
            </dd>
          </dl>

          <dl>
            <dt>車両に異常があった場合はどうしたらいいですか？</dt>
            <dd>
              <p>車両に異常のある場合は、ご利用にならず速やかにスズキ定額マイカーお客様センターへご連絡ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>タイヤやワイパーなど、消耗品が破損した場合はどうしたらよいですか？</dt>
            <dd>
              <p>消耗部品はお客様のご負担となります。（パンク等によるタイヤ交換含む）</p>
            </dd>
          </dl>

          <dl>
            <dt>契約内容の変更（住所、クレジットカード情報など）をするにはどうしたらよいですか？</dt>
            <dd>
              <p>スズキ定額マイカーお客様センターへご連絡ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>契約期間中に解約したい場合はどうすればよいですか？</dt>
            <dd>
              <p>解約希望の旨をスズキ定額マイカーお客様センターにご連絡ください。<br>
                残契約期間に応じて、中途解約金をお支払いいただき、取り扱い店舗にクルマを返却いただいて解約となります。<br>
                返却時の車両の状態によって、清算金（原状回復費用）が発生する場合があります。</p>
            </dd>
          </dl>

          <dl>
            <dt>返却の手続きはどうしたらよいですか？</dt>
            <dd>
              <p>満期の約１カ月前にメールにてご案内いたします。メールが届いてから5日以内に、契約終了し返却するか、再契約するかをご返信ください。<br>
                  ご返信がない場合には、返却となりますので、ご了承ください。</p>
            </dd>
          </dl>

        </div>
        <!-- /ご利用中 -->

        <!-- その他 -->
        <div class="top-qa-content-in sans con-6">

          <dl>
            <dt>現在加入している自動車保険を使えますか？</dt>
            <dd>
              <p>使用できません。加入中の保険がある場合は、中断手続きができる場合がありますので、加入中の保険の取扱代理店・引受保険会社にご相談ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>事故が起こったときはどうすればいいですか？</dt>
            <dd>
              <p>まずは、速やかに自動車保険会社のコールセンターに連絡してください。併せて、スズキ定額マイカーお客様センターまでご連絡ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>車両が盗難にあった場合の対応について</dt>
            <dd>
              <p>スズキ定額マイカーお客様センターまでご連絡ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>修理を知り合いの工場に依頼をしてもよいですか？</dt>
            <dd>
              <p>修理は、車両受け渡し店舗にて実施いたしますので、スズキ定額マイカーお客様センターまでご連絡ください。ご連絡いただけない場合は、補償制度が適用できませんのでご注意ください。</p>
            </dd>
          </dl>

          <dl>
            <dt>利用期間後も継続して車を利用したい場合は、どうすればよいですか？</dt>
            <dd>
              <p>満期の約１カ月前に送信するメールに、再契約の旨をご返信ください。<br>
                 併せて新規申し込み時と同様にホームページから申し込み手続き・審査を進めて下さい。審査完了後、取扱店舗と来店希望日を調整のうえご来店いただき、再契約手続き、およびクルマのメンテナンス作業を行います。</p>
            </dd>
          </dl>

          <dl>
            <dt>利用しているクルマを購入することはできますか？</dt>
            <dd>
              <p>購入することは出来ません</p>
            </dd>
          </dl>

        </div>
        <!-- /その他 -->

      </div>
    </div>
    <!-- /よくあるご質問・ご相談 -->

    <!-- お気軽にお問い合わせください -->
    <div id="top-sec-contact" class="top-contact-content">
      <div class="wrapper">

        <!-- 見出し -->
        <center>
          <div class="top-contact-content-title">
            ご不明な点・ご質問など<br>お気軽にお問い合わせください
          </div>
        </center>
        <!-- /見出し -->

        <div class="top-contact-content-main-text">
          スズキ定額マイカーお客様センター
          <div class="top-contact-content-main-text-tel">
            <span class="tel-link">0120-3249-66</span><span class="mini">（通話料無料）</span>
          </div>
          <div class="top-contact-content-main-text-time">
            受付時間：10:00～17:00<span class="mini">（年末年始除く）</span>
          </div>
        </div>

        <center>
          <router-link to="/inquiry" class="top-contact-content-btn">
            お問い合わせフォームはこちら
          </router-link>
        </center>

        <div class="top-contact-content-text sans">
          お問い合わせの内容によっては、<br class="mobi">回答にお時間を頂戴する場合がございます。<br>
          予めご了承くださいますようお願いいたします。
        </div>

        <!-- メルマガ登録フォーム -->
        <mail-magazine-form />
        <!-- /メルマガ登録フォーム -->

      </div>
    </div>
    <!-- /お気軽にお問い合わせください -->

  </div>
  <!-- /top-main-content -->

  <!-- top-aisatsu-content -->
  <div class="top-aisatsu-content">
    <div class="wrapper">

      <center>
        <div class="top-aisatsu-content-img">
          <img src="~@/assets/images/aisatsu-main-img.png" width="1100" height="550" class="pc tab">
          <img src="~@/assets/images-sp/aisatsu-main-img.png" width="650" height="350" class="mobi">
        </div>
      </center>

      <div class="top-aisatsu-content-text">
        <p>みんなが乗れるクルマづくりを、<br class="mobi">クルマとの付き合い方まで広げたい。<br>
        そんな想いをカタチにした、<br>暮らしをちょっとよくする<br class="mobi">サブスクリプションサービス。</p>

        <p>手軽な乗り方で、身軽なくらしが走り出す。<br>
        あなたの生活にフィットしたカーライフを、<br class="mobi">はじめてみませんか。</p>
      </div>

    </div>
  </div>
  <!-- /top-aisatsu-content -->
  </page>
</template>
<!-- eslint-enable no-irregular-whitespace -->
<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';
import globalScript from '@/global';
import scripts from '@/assets/top.js';
import commonScripts from '@/assets/common.js';
import Page from '@/components/Page.vue';
import MailMagazineForm from '@/components/MailMagazineForm.vue';

import { getRecommendItems } from '@/api/recommendItem';
import { getNotices } from '@/api/notice';

import { RecommendItem } from '@/api/recommendItem/type';
import { Notice } from '@/api/notice/type';

export default defineComponent({
  name: 'Home',
  components: {
    Page,
    MailMagazineForm,
  },
  setup () {

    const notices = ref<Notice[]>([]);
    const lineupLight = ref<RecommendItem[]>([]);
    const lineupNormal = ref<RecommendItem[]>([]);
    const loading = ref(true);

    onMounted(async () => {
      await globalScript();
      scripts.topScript();

      try {
        const notice = await getNotices();
        notices.value = notice.data;
      } catch(e) {
        // console.log(e);
      }

      try {
        const recommendItem = await getRecommendItems();
        lineupLight.value = recommendItem.data.filter(item => item.lightOrSmall === 0);
        lineupNormal.value = recommendItem.data.filter(item => item.lightOrSmall === 1);
      } catch(e) {
        // console.log(e);
      }

      loading.value = false,
      setTimeout(() => {
        scripts.sliderScript();
      }, 100);
    });

    onBeforeUnmount(() => {
      commonScripts.unslick();
    });

    return { loading, lineupLight, lineupNormal, notices };
  },
});
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/tab-top';
  @import '~@/assets/styles/mobile';
  .header-logo {
    margin-top: 80px;
  }
</style>